import React, {Component} from "react";
import { Button,Alert,Row,CardTitle,Col,Card,CardBody } from "reactstrap";
import {ajaxWrapperGet, ajaxWrapperPost} from "../../utils/deviceAPI";
import UsersNotificationSystem from "../../views/Admin/Users/UsersNotificationSystem";
import NotificationHOC from "../Notifications/NotificationHOC";



class WhatsNew extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            data:[]
        }

    }
    componentDidMount() {
        this.setData();
        this.setState({
            loading: false
        })

    }
    setData() {
        ajaxWrapperGet('/whatsNew').then((data) => {
            console.log(data);
            this.setState({
                data,
                loading: false
            });
        });
    }
    hideWhatsNew() {
        let postData = {
            hide: true
        };
        ajaxWrapperPost('/whatsNewHide',postData).then((data) => {
            console.log(data);
            if (data.error === false) {
                this.setData();
            }
            else if (data.error === true) {
            }
        });
    }
    render() {
        if (this.state.data.length >= 1) return (
            <Row>
                <Col xs="12" lg="12">
                    <Card>
                        <CardBody className="card-body">
                            <Row className="pb-2">
                                <Col sm="12">
                                    <CardTitle className="mb-1">Whats New!</CardTitle>
                                    <div className="small text-muted mb-5">list of new features, improvements or updates</div>
                                    {this.state.data.map((item,index) => {
                                        return (
                                            <Row key={index} className="mt-2 mb-2">
                                                <Col sm="2" md="1">{item.version}</Col>
                                                <Col sm="10" md="11" className="text-muted small">{item.note}</Col>
                                            </Row>
                                        )
                                    })}
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="12" className="text-center">
                                    <button className="btn btn-link text-black-50" onClick={() => this.hideWhatsNew()}>Thanks, hide this until next version!</button>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        );
        else return ("")
    }
}

export default WhatsNew;



// WEBPACK FOOTER //
// ./src/components/WhatsNew/WhatsNew.js